import React, { useState } from "react";

import StyledScrollbar from "../../../../UIComponents/StyledScrollbar";
import { useTemplateContext } from "../../../TemplateContext";
import BuilderPreview from "../Preview/BuilderPreview";
import COABuilderCenterContent from "./CustomCOABuilderCenter/COABuilderCenterContent";
import EditPreviewButton from "./EditPreviewButton";
import "./TemplateBuilderCenter.css";
import TemplateBuilderCenterContent from "./TemplateBuilderCenter/TemplateBuilderCenterContent";

export default function TemplateBuilderCenter(props) {
  const {
    previewTemplate,
    handlePreviewTemplate,
    dataFields,
    handleSectionSelect,
    sections,
    sectionsFixed,
    sectionRefs,
    setSectionInputs,
    handleBuilderFile,
    handleTemplateDataFieldsChange,
    inputsPayload,
    isCustomizingCoa,
    selectedTemplate,
    selectedReports,
    handleCreateSection,
    handleSectionDelete,
    uniqueTests,
    enableTests,
    isReadOnlyCoaTemplate,
  } = props;
  const showPreview = previewTemplate || isReadOnlyCoaTemplate;
  const { side } = useTemplateContext();
  const [loadingPreview, setLoadingPreview] = useState(false);
  return (
    <div className="TemplateBuilder__CenterContainer">
      {!isReadOnlyCoaTemplate && (
        <EditPreviewButton
          previewTemplate={previewTemplate}
          handlePreviewTemplate={handlePreviewTemplate}
          loadingPreview={loadingPreview}
          setLoadingPreview={setLoadingPreview}
        />
      )}
      {showPreview && (
      <BuilderPreview
        inputs={inputsPayload}
        isCustomizingCoa={isCustomizingCoa}
        setLoadingPreview={setLoadingPreview}
        uniqueTests={uniqueTests}
        enableTests={enableTests}
        side={side}
        templateId={selectedTemplate?.template_id}
      />
      )}
      <div className={!showPreview ? "templateBuilderCenter" : "builderSectionHide"}>
        <StyledScrollbar>
          {isCustomizingCoa ? (
            <COABuilderCenterContent
              sections={sections}
              setSectionInputs={setSectionInputs}
              handleTemplateDataFieldsChange={handleTemplateDataFieldsChange}
              selectedTemplate={selectedTemplate}
              selectedReports={selectedReports}
              handleBuilderFile={handleBuilderFile}
              handleCreateSection={handleCreateSection}
              handleSectionDelete={handleSectionDelete}
              uniqueTests={uniqueTests}
              enableTests={enableTests}
            />
          ) : (
            <TemplateBuilderCenterContent
              dataFields={dataFields}
              handleSectionSelect={handleSectionSelect}
              sections={sections}
              sectionsFixed={sectionsFixed}
              sectionRefs={sectionRefs}
              setSectionInputs={setSectionInputs}
              handleBuilderFile={handleBuilderFile}
              handleTemplateDataFieldsChange={handleTemplateDataFieldsChange}
            />
          )}
        </StyledScrollbar>
      </div>
    </div>

  );
}
